// extracted by mini-css-extract-plugin
export default {"reviews":"Reviews_reviews__+HrX2","close-button":"Reviews_close-button__EhxQr","show-all-reviews":"Reviews_show-all-reviews__jGOK1"};